// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsSettings = {
  aws_appsync_graphqlEndpoint: "https://6n6g7552xzb5zca3yhhnicxsai.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  //aws_appsync_authenticationType: "API_KEY",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-e2g4qs4oo5flnab2f2ndnk43fq",
  aws_api_auth: "https://w4f2z4c35e.execute-api.us-east-1.amazonaws.com/dev/users",
};

export default awsSettings;
